import theme from '@app/ui/theme'
import styled from 'styled-components'

export const Container = styled.div<{ selected: boolean }>`
  cursor: pointer;
  min-width: 100px;
  width: 100px;
  height: 56px;
  background-color: ${({ selected }) =>
    selected ? theme.colors.secondary2 : 'transparent'};
  border-radius: 5px;
  text-align: center;
  flex-direction: column;
  display: flex;
  border: ${({ selected }) =>
    selected ? `1px solid ${theme.colors.secondary2}` : `1px solid #e0e0e0`};
`

export const HoleText = styled.span<{ selected: boolean }>`
  color: ${({ selected }) => (selected ? '#fff' : '#000000')};
  font-size: 16px;
  font-weight: 500;
  flex: 1;
  white-space: nowrap;
`

export const HoleValueText = styled(HoleText)`
  color: ${({ selected }) => (selected ? '#fff' : '#000000')};
  font-weight: 600;
`

export const GHNText = styled.span<{ selected: boolean }>`
  color: ${({ selected }) => (selected ? '#fff' : '#000000')};
  font-weight: 400;
  font-size: 14px;
  flex: 1;
`

export const GHNValueText = styled(GHNText)`
  font-weight: 600;
`
